<template>
<div>
  <!-- <v-btn @click="showDetailForm()">فرم جزییات</v-btn> -->
  <v-card>
    <v-card-title>
      مدیریت سفارشات
            <v-spacer/>
      <v-btn @click="createNewItem()" color="primary">ثبت سفارش +</v-btn>
      </v-card-title>
      <v-divider></v-divider>
    <v-card-text>
  
  <!-- <trade-request-list ref="TradeRequestList" v-if="!$store.getters.tradeRequestIsEdit && !$store.getters.tradeRequestFormStatus "></trade-request-list> -->
  <trade-request-list ref="TradeRequestList"></trade-request-list>

  <!-- <trade-request-form ref="TradeRequestForm" v-if="($store.getters.tradeRequestIsEdit || $store.getters.tradeRequestFormStatus ) && !$store.getters.tradeRequestShowDetailForm "></trade-request-form>
  <trade-request-information ref="TradeRequestInfo" v-else-if="$store.getters.tradeRequestShowDetailForm && $store.getters.tradeRequestFormStatus "></trade-request-information> -->
</v-card-text>
</v-card>
</div>
</template>

<script>
import TradeRequestList from '@/modules/tradeRequests/components/TradeRequestList.vue';
import TradeRequestForm from '@/modules/tradeRequests/components/TradeRequestForm.vue';
import TradeRequestInformation from '../components/TradeRequestInformation.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestList,
    // TradeRequestForm,
    // TradeRequestInformation,
  },
  methods: {
    showDetailForm(){
      this.$store.commit('setTradeRequestSelectedForDisplay', null)
      this.$store.commit('setTradeRequestSingleItemForEdit', null)
      this.$store.commit('setTradeRequestItems', [])
      this.$store.commit('setTradeRequestSingleItem', null)
      this.$store.commit('setAllTradeRequests', [])
      this.$store.commit('setTradeRequestFormStatus', false)
      this.$store.commit('setTradeRequestEditMode', false)
      /////////
      this.$store.commit('setTradeRequestIsEdit', false)
      this.$store.commit('setTradeRequestShowDetailForm', true)
      this.$store.commit('setTradeRequestSelectedForEdit', null)

    },
    createNewItem(){
      this.$store.commit('setTradeRequestSelectedForDisplay', null)
      this.$store.commit('setTradeRequestSingleItemForEdit', null)
      this.$store.commit('setTradeRequestItems', [])
      this.$store.commit('setTradeRequestSingleItem', null)
      this.$store.commit('setAllTradeRequests', [])
      this.$store.commit('setTradeRequestEditMode', false)
      ///////
      this.$store.commit('setTradeRequestFormStatus', true)

      this.$store.commit('setTradeRequestIsEdit', false)
      this.$store.commit('setTradeRequestShowDetailForm', false)
      this.$store.commit('setTradeRequestSelectedForEdit', null)
      this.$router.push({path:'/trade-request-form'})

    }
  },
};
</script>

<style></style>
